
import { defineComponent, computed, PropType, Prop } from 'vue'

import FtlAdditionalServiceTable from '@/modules/FTLModule/components/FtlAdditionalServiceTable/index.vue'
import FtlCostTable from '@/modules/FTLModule/components/FtlCostTable/index.vue'

import { AdditionalServicesFTLI } from '@/core/types/additional_services.types'
import { DowntimeFullT, FullFTLOrderT } from '@/core/types/orders.types'

type SharedAdditionalService = AdditionalServicesFTLI & {
    type_of_stock: string
}

export default defineComponent({
    components: {
        FtlAdditionalServiceTable,
        FtlCostTable,
    },
    props: {
        senderCity: {
            type: String,
            default: null,
        },
        additionalService: {
            type: Array as PropType<SharedAdditionalService[]>,
            default: () => [],
        },
        paymentMethod: {
            type: String,
            default: null,
        },
        declaredPrice: {
            type: Number,
            default: null,
        },
        paymentType: {
            type: String,
            default: null,
        },
        isPrepayment: {
            type: [Number, Boolean],
            default: false,
        },
        costPriceWithNds: {
            type: Number,
            default: null,
        },
        ftlType: {
            type: Number,
            default: null,
        },
        paymentRateTypeId: {
            type: Number,
            default: null,
        },
        costPricePerHour: {
            type: Number,
            default: null,
        },
        costPrice: {
            type: Number,
            default: null,
        },
        costTotal: {
            type: Number,
            default: null,
        },
        paidPricePerHour: {
            type: Number,
            default: null,
        },
        paidPrice: {
            type: Number,
            default: null,
        },
        paidPriceTotal: {
            type: Number,
            default: null,
        },
        companyName: {
            type: String,
            default: null,
        },
        downtime: {
            type: Object as PropType<DowntimeFullT>,
            default: null,
        },
        ftlOrder: {
            type: Object as PropType<FullFTLOrderT>,
            default: null,
        },
    },
    setup(props) {
        const formatAmount = (amount: string | number | null) => {
            if (amount) {
                return `${amount.toLocaleString('ru-RU')} ₸`
            }

            return '-'
        }

        const costPriceTitle = computed(() => {
            let title = 'Себестоимость за перевозку'

            if (props.costPriceWithNds === 1) {
                title += ' (с НДС)'
            } else {
                title += ' (без НДС)'
            }

            if (props.ftlType === 2) {
                if (props.paymentRateTypeId === 2) {
                    title += ' за рейс'
                } else {
                    title += ' за час'
                }
            }

            return title
        })

        const costPriceValue = computed(() => {
            let cost_price = null as string | number | null

            if (props.paymentRateTypeId === 1) {
                cost_price = props.costPricePerHour
            } else {
                cost_price = props.costPrice
            }

            return formatAmount(cost_price)
        })

        const paidPriceTitle = computed(() => {
            let title = 'Выставление клиенту за перевозку'

            if (props.ftlType === 2) {
                if (props.paymentRateTypeId === 1) {
                    title += ' за час'
                } else {
                    title += ' за рейс'
                }
            }

            return title
        })

        return {
            formatAmount,
            costPriceTitle,
            costPriceValue,
            paidPriceTitle,
        }
    },
})
